
import './App.css';
import PrivacyPolicy from './privacypolicy';
function App() {
  return (
    <div className="App">
     <PrivacyPolicy/>
    </div>
  );
}

export default App;
